import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function DataTableFacetedFilter({ column, options }) {
  const selectedValue = column?.getFilterValue();
  const facets = column?.getFacetedUniqueValues?.();

  const totalCount = Array.from(facets?.values?.() ?? []).reduce(
    (acc, count) => acc + count,
    0,
  );

  const handleClick = (value) => {
    if (value === 'all') {
      column?.setFilterValue(undefined);
    } else {
      column?.setFilterValue(value);
    }
  };

  return (
    <div className="flex items-center gap-2">
      {options.map((option, index) => {
        const isAll = option.value === 'all';

        // ✅ Highlight the first button when nothing is selected
        const isSelected =
          selectedValue === option.value ||
          (selectedValue === undefined && index === 0);

        const count = isAll ? totalCount : facets?.get(option.value);

        return (
          <Button
            key={option.value}
            variant={isSelected ? 'outline' : 'ghost'}
            className={cn(
              'h-8 px-3 text-sm whitespace-nowrap shrink-0 w-auto',
              {
                'border-2 border-primary': isSelected,
              },
            )}
            onClick={() => handleClick(option.value)}
          >
            {option.icon && <option.icon className="mr-1.5 h-4 w-4" />}
            {option.label}
            {count !== undefined && (
              <span className="ml-1 text-muted-foreground">({count})</span>
            )}
          </Button>
        );
      })}
    </div>
  );
}
